export default "__VITE_ASSET__DbiSX6v$__"